import { router } from "@/core";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { defineComponent, ref } from "vue";
import { circulationStatusArr } from "./maintenance-status-tabs.constant";
import { get, post } from "./maintenance-status-tabs.service";
import { TabsType } from "./maintenance-status-tabs.interface";
import _ from "lodash";

export default defineComponent({
  isGlobal: true,
  name: "MaintenanceStatusTab",
  components: {},
  props: {
    path: {
      type: String,
      require: true,
    },
    statusType: {
      type: String,
      default: "project",
    },
    value: {
      type: String,
    },
    accessSource: {
      type: Number,
      default: 0,
    },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    let { data, run, refresh } = post();
    let flowCountMap = new Map();
    let total = 0;

    let flowStatusArr = ref([]);

    // flowStatusArr = circulationStatusArr;
    const fetchStatusCount = async () => {
      await run(props.path, { accessSource: props.accessSource });
      getCount();
    };
    const getCount = () => {
      total = 0;
      flowCountMap.clear();
      // // console.log(
      //   "🚀 ~ file: project-status-tab.controller.ts:45 ~ getCount ~ flowCountMap:",
      //   flowCountMap
      // );
      flowStatusArr.value = data.value?.records || [];
      // list.map((d) => {
      //   flowCountMap.set(d.code, d);
      //   total += d.count;
      // });
      // flowStatusArr.map((item) => {
      //   item["total"] = flowCountMap.get(item.type)?.count || 0;
      //   if (item.type == "all") {
      //     item["total"] = total;
      //   }
      // });
    };

    const changeTab = (p) => {
      emit("update:value", p);
    };

    onMountedOrActivated(async () => {
      await fetchStatusCount();
    });

    const onProjectDesign = () => {
      router.push("/project/profile/create");
    };

    return {
      flowStatusArr,
      changeTab,
      getCount,
      onProjectDesign,
      fetchStatusCount,
    };
  },
});
